import { PropsWithChildren, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { SidebarSectionToggle } from './SidebarSectionToggle'
import { GreyGrey30, Box } from '@sequencehq/core-components'

type Props = PropsWithChildren<{
  title: string
  showBorder?: boolean
  'data-testid': string
}>

export const SidebarSection = ({
  title,
  children,
  showBorder,
  'data-testid': dataTestId
}: Props) => {
  const [isVisible, setIsVisible] = useState(true)

  return (
    <Box
      borderBottom={showBorder ? `1px solid ${GreyGrey30}` : undefined}
      width="100%"
      data-testid={dataTestId}
    >
      <SidebarSectionToggle
        isVisible={isVisible}
        toggle={() => setIsVisible(visible => !visible)}
        text={title}
        data-testid={`${dataTestId}.toggle`}
      />
      <AnimatePresence initial={false}>
        {isVisible && (
          <motion.div
            initial={{ height: '0px' }}
            animate={{ height: 'fit-content' }}
            exit={{ height: '0px' }}
            style={{
              overflow: 'hidden'
            }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  )
}
